import script from "./infos.vue?vue&type=script&setup=true&lang=ts"
export * from "./infos.vue?vue&type=script&setup=true&lang=ts"

import "./infos.vue?vue&type=style&index=0&id=2090c15c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2090c15c"]])

export default __exports__